import { render } from "./CpfInput.vue?vue&type=template&id=bb294442&ts=true"
import script from "./CpfInput.vue?vue&type=script&lang=ts"
export * from "./CpfInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__